import LoginPage from '../components/login/login-page';
import AdminLoginPage from '../components/admin/login/login-page';
import Logout from '../components/logout/index';
import AdminLogout from '../components/admin/logout/index';
import OutletValidationForm from '../components/outlet-validation/outlet-validation-form';
import YourStoreForm from '../components/your-store';
import ForgottenPasswordForm from '../components/auth/forgotten-password-1';
import PINForm from '../components/auth/forgotten-password-2';
import SeqQuestionsForm from '../components/auth/security-questions';
import NewPasswordForm from '../components/auth/new-password';
import StoreSummary from '../components/store-summary/index';
import StoreSummaryReg from '../components/store-summary/index-registration';
import StoreDetails from '../components/store-details/index';
import MyStaff from '../components/my-staff/index';
import NewOrder from '../components/new-order';
import OrderConfirmation from '../components/new-order/confirm';
import MyOrders from '../components/my-orders';
import ViewOrder from '../components/my-orders/view';
import AboutYou from '../components/about-you/index';
import MyProfile from '../components/my-profile';
import AdminMyProfile from '../components/admin/my-profile';
import UpdatePassword from '../components/update-password';
import AdminUpdatePassword from '../components/admin/update-password';
import UpdateSecurityQuestions from '../components/update-security-questions';
import AdminUpdateSecurityQuestions from '../components/admin/update-security-questions';
import HomePage from '../components/home/home-page';
import AdminHomePage from '../components/admin/home/index';
import Welcome from '../components/admin/welcome';
import UserGroups from '../components/admin/usergroups/list/index';
import EditUserGroup from '../components/admin/usergroups/edit/index';
import Users from '../components/admin/users/list/index';
import EditUser from '../components/admin/users/edit/edit';
import UserDetails from '../components/admin/users/edit/details';
import UserUpdateSecurityQuestions from '../components/admin/users/edit/update-security-question';
import Notifications from '../components/admin/notifications/list';
import Notification from '../components/admin/notifications/edit';
import Pages from '../components/pages';
import AddEditPages from '../components/pages/add-edit';
import PersonalRewards from '../components/personal-rewards';
import StaffRewards from '../components/staff-rewards/index';
import HowToEarn from '../components/how-to-earn';
import OutletView from '../components/admin/outlet-view';
import OutletRewardAllocationView from '../components/admin/outlet-reward-allocation-view';
import OutletList from '../components/admin/outlet-list';
import DelinkPage from '../components/admin/delink';
import SiteDesign from '../components/site-design';
import DataImport from '../components/admin/data-import';
import DataExport from '../components/admin/data-export';
import Categories from '../components/admin/products/categories/list/index';
import EditCategory from '../components/admin/products/categories/edit/index';
import Brands from '../components/admin/products/brands/list/index';
import EditBrand from '../components/admin/products/brands/edit/index';
import Products from '../components/admin/products/products/list/index';
import Orders from '../components/admin/orders';
import OrderLimits from '../components/admin/order-limits/list/index';
import EditOrderLimit from '../components/admin/order-limits/edit/index';
import StaffRewardSettings from '../components/admin/staff-reward/settings';
import StaffRewardRedemptions from '../components/admin/staff-reward/redemptions';
import NewProduct from '../components/admin/products/products/add/index';
import PpcSettings from '../components/admin/ppc/settings';
import PpcManagement from '../components/admin/ppc/management';
import PpcUser from '../components/admin/ppc/user';
import PpcLoad from '../components/admin/ppc/load';
import PpcManualLoad from '../components/admin/ppc/load-manual';
import PointsExpiry from '../components/admin/points/points-expiry/index';
import PointsTransactions from '../components/admin/points/points-transactions/index';
import ManualPointsTransactions from '../components/admin/points/manual-points-transactions/index';
import AddIncentives from '../components/admin/incentives/add-incentives/index';
import Incentives from '../components/admin/incentives/index';
import StorePerformance from '../components/store-performance/index';
import NewsCategories from '../components/admin/news/categories/list';
import EditNewsCategories from '../components/admin/news/categories/edit';
import NewsArticles from '../components/admin/news/articles/list';
import EditNewsArticles from '../components/admin/news/articles/edit';
import PointsStatement from '../components/points-statement/index';
import AdminHomePageMenu from '../components/admin/homepagemenu/index';
import NewCarousel from '../components/admin/homepagemenu/add-carousel/index';
import EditTile from '../components/admin/homepage-tiles/edit-tile/index';
import DynamicEditTile from '../components/admin/homepage-tiles/dynamic-edit-tile/index';
import ContactUsPre from '../components/contact-us/pre-login/index';
import ContactUsPost from '../components/contact-us/post-login/index';
import AboutIgnite from '../components/about-ignite/index';
import ContentPage from '../components/admin/content-page';
import LatestNews from '../components/latest-news/index';
import Article from '../components/article/index';
import MyMessages from '../components/my-messages';
import Downloads from '../components/admin/downloads/list';
import EditDownload from '../components/admin/downloads/edit';
import GroupsPage from '../components/admin/groups/list/groups-page';
import GroupsFormPage from '../components/admin/groups/form/group-form-page';
import Promotions from '../components/admin/promotions/promotions/list/index';
import NewPromotion from '../components/admin/promotions/promotions/add/index';
import PromotionalBanners from '../components/admin/promotions/promotional_banners/list/index';
import NewPromotionalBanner from '../components/admin/promotions/promotional_banners/add/index';
import UpsellPopups from '../components/admin/promotions/upsell_popups/list/index';
import NewUpsellPopup from '../components/admin/promotions/upsell_popups/add/index';
import SamlSso from '../components/elearning/saml_sso';
import FailedSso from '../components/elearning/failed_sso';
import PrizeFormPage from '../components/admin/prizes/edit/prize-form-page';
import PrizesPage from '../components/admin/prizes/list/index';
import BrandPage from '../components/brand-page';
import PasswordResetReceiver from '../components/auth/password-reset-receiver';
import StockItIncentives from '../components/stock-it-incentives';
import StockItResults from '../components/stock-it-results';
import AdminStockItIncentives from '../components/admin/stock-it-incentives/index';
import AddStockItIncentives from "../components/admin/stock-it-incentives/add-stock-it-incentives/index";
import FeatureTogglesList from '../components/admin/feature-toggles/list';
import featureToggleFormPage from '../components/admin/feature-toggles/form/feature-toggle-form-page';
import MyRewardsPage from '../components/my-rewards';
import MyIncentivesPage from '../components/my-incentives';
import Games from '../components/admin/games/list/index';
import GameFormPage from '../components/admin/games/form/index';

export const mainRoutes = {
  public: [],
  private: [
    {
      path: '/',
      component: HomePage,
      exact: true
    },
    {
      path: '/my-incentives',
      component: MyIncentivesPage,
    },
    {
      path: '/my-rewards',
      component: MyRewardsPage,
    },
    {
      path: '/outlet',
      component: OutletValidationForm
    },
    {
      path: '/store-summary',
      component: StoreSummary
    },
    {
      path: '/about-you',
      component: AboutYou
    },
    {
      path: '/store-details/:id',
      component: StoreDetails
    },
    {
      path: '/your-store',
      component: YourStoreForm
    },
    {
      path: '/my-staff',
      component: MyStaff,
      permissions: {
        action: 'handle',
        subjectClass: 'staff'
      }
    },
    {
      path: '/order/new',
      exact: true,
      component: NewOrder,
      permissions: {
        action: 'order,read',
        subjectClass: 'stock'
      }
    },
    {
      path: '/order/:id/confirm',
      component: OrderConfirmation,
      permissions: {
        action: 'order,read',
        subjectClass: 'stock'
      }
    },
    {
      path: '/my-orders',
      exact: true,
      component: MyOrders,
      permissions: {
        action: 'order,read',
        subjectClass: 'stock'
      }
    },
    {
      path: '/points-statement',
      exact: true,
      component: PointsStatement
    },
    {
      path: '/my-orders/:id',
      component: ViewOrder
    },
    {
      path: '/my-profile',
      component: MyProfile
    },
    {
      path: '/update-password',
      component: UpdatePassword,
      permissions: {
        action: 'update',
        subjectClass: 'personal_info'
      }
    },
    {
      path: '/update-security-questions',
      component: UpdateSecurityQuestions,
      permissions: {
        action: 'update',
        subjectClass: 'personal_info'
      }
    },
    {
      path: '/site-design',
      component: SiteDesign
    },
    {
      path: '/store-performances',
      component: StorePerformance,
      permissions: {
        action: 'view',
        subjectClass: 'objective_info,objective_performance'
      }
    },
    {
      path: '/stock-it-incentives',
      component: StockItIncentives,
      permissions: {
        action: 'view',
        subjectClass: 'objective_info,objective_performance'
      }
    },
    {
      path: '/stock-it-results/:id',
      component: StockItResults,
      permissions: {
        action: 'view',
        subjectClass: 'objective_info,obejctive_performance'
      }
    },
    {
      path: '/staff-rewards',
      component: StaffRewards,
      permissions: {
        action: 'handle',
        subjectClass: 'staff_rewards'
      }
    },
    {
      path: '/personal-rewards',
      component: PersonalRewards,
      permissions: {
        action: 'index',
        subjectClass: 'personal_rewards'
      }
    },
    {
      path: '/how-to-earn',
      component: HowToEarn,
      permissions: {
        action: 'view',
        subjectClass: 'objective_info,objective_performance'
      }
    },
    {
      path: '/contact-us',
      component: ContactUsPost
    },
    {
      path: '/about-ignite',
      component: AboutIgnite
    },
    {
      path: '/latest-news',
      component: LatestNews
    },
    {
      path: '/article/:id',
      component: Article
    },
    {
      path: '/my-messages',
      component: MyMessages
    },
    {
      path: '/content-page/edit/(brands/)?:pageSlug',
      component: ContentPage,
      permissions: {
        action: 'edit',
        subjectClass: 'Page'
      }
    },
    {
      path: '/elearning',
      component: SamlSso,
      permissions: {
        action: 'view',
        subjectClass: 'e_learning'
      }
    },
    {
      path: '/failed-sso',
      component: FailedSso
    },
    {
      path: '/brands/:slug',
      component: BrandPage
    }
  ]
};

export const emptyRoutes = {
  public: [
    {
      path: '/login',
      component: LoginPage,
      exact: true
    },
    {
      path: '/password-reset-link/:id',
      component: PasswordResetReceiver
    },
    {
      path: '/reset-password',
      component: ForgottenPasswordForm
    },
    {
      path: '/enter-pin',
      component: PINForm
    },
    {
      path: '/seq-questions',
      component: SeqQuestionsForm
    },
    {
      path: '/new-password',
      component: NewPasswordForm
    },
    {
      path: '/registration/outlet',
      component: OutletValidationForm
    },
    {
      path: '/registration/about-you',
      component: AboutYou
    },
    {
      path: '/users/about_you',
      component: AboutYou
    },
    {
      path: '/registration/your-store',
      component: YourStoreForm
    },
    {
      path: '/registration/store-summary',
      component: StoreSummaryReg
    },
    {
      path: '/logout',
      component: Logout,
      exact: true
    },
    {
      path: '/admin/login',
      component: AdminLoginPage,
      hideFooter: true,
      exact: true
    },
    {
      path: '/admin/welcome',
      component: Welcome
    },
    {
      path: '/contact',
      component: ContactUsPre
    }
    // {
    //   path: '/content-pages/:pageSlug',
    //   exactMatch: true,
    //   component: ContentPage,
    // },
  ],
  private: []
};

export const adminMainRoutes = [
  {
    path: '/admin',
    component: AdminHomePage,
    exact: true
  },
  {
    path: '/admin/logout',
    component: AdminLogout,
    exact: true
  },
  {
    path: '/admin/my-profile',
    component: AdminMyProfile,
    exact: true
  },
  {
    path: '/admin/homepage',
    component: AdminHomePageMenu,
    exact: true,
    permissions: {
      action: 'handle',
      subjectClass: 'home_page'
    }
  },
  {
    path: '/admin/homepage/carousel/new',
    component: NewCarousel,
    exact: true
  },
  {
    path: '/admin/homepage/carousel/:id/edit',
    component: NewCarousel,
    exact: true
  },
  {
    path: '/admin/outlets',
    component: OutletList,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'Outlet'
    }
  },
  {
    path: '/admin/outlets/:id/view',
    component: OutletView,
    permissions: {
      action: 'manage',
      subjectClass: 'Outlet'
    }
  },
  {
    path: '/admin/outlets/:id?/delink',
    component: DelinkPage,
    permissions: {
      action: 'delink',
      subjectClass: 'Outlet'
    }
  },
  {
    path: '/admin/outlet-reward-allocations/:incentives_outlets_id/view',
    component: OutletRewardAllocationView,
    permissions: {
      action: 'manage',
      subjectClass: 'Outlet'
    }
  },
  {
    path: '/admin/groups',
    component: GroupsPage,
    exact: true,
    permissions: {
      action: 'handle',
      subjectClass: 'Group'
    }
  },
  {
    path: '/admin/groups/new',
    component: GroupsFormPage,
    permissions: {
      action: 'create',
      subjectClass: 'Group'
    }
  },
  {
    path: '/admin/groups/:id',
    component: GroupsFormPage,
    permissions: {
      action: 'update',
      subjectClass: 'Group'
    }
  },
  {
    path: '/admin/user-groups',
    component: UserGroups,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'UserGroup'
    }
  },
  {
    path: '/admin/user-groups/new',
    component: EditUserGroup,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'UserGroup'
    }
  },
  {
    path: '/admin/user-groups/:id',
    component: EditUserGroup,
    permissions: {
      action: 'update',
      subjectClass: 'UserGroup'
    }
  },
  {
    path: '/admin/users',
    component: Users,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'User'
    }
  },
  {
    path: '/admin/users/new',
    component: EditUser,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'User'
    }
  },
  {
    path: '/admin/users/:id/edit',
    component: EditUser,
    exact: true,
    permissions: {
      action: 'edit',
      subjectClass: 'User'
    }
  },
  {
    path: '/admin/users/:id/details',
    component: UserDetails,
    exact: true,
    permissions: {
      action: 'edit',
      subjectClass: 'User'
    }
  },
  {
    path: '/admin/users/:id/details/security-questions',
    component: UserUpdateSecurityQuestions,
    exact: true,
    permissions: {
      action: 'edit',
      subjectClass: 'User'
    }
  },
  {
    path: '/admin/update-password',
    component: AdminUpdatePassword
  },
  {
    path: '/admin/update-security-questions',
    component: AdminUpdateSecurityQuestions
  },
  {
    path: '/admin/pages',
    component: Pages,
    permissions: {
      action: 'index',
      subjectClass: 'Page'
    }
  },
  {
    path: '/admin/pages-add-edit/new',
    component: AddEditPages,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Page'
    }
  },
  {
    path: '/admin/pages-add-edit/:id',
    component: AddEditPages,
    permissions: {
      action: 'update',
      subjectClass: 'Page'
    }
  },
  {
    path: '/admin/pages-add-edit',
    component: AddEditPages,
    permissions: {
      action: 'update',
      subjectClass: 'Page'
    }
  },
  {
    path: '/admin/notifications',
    component: Notifications,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Notification'
    }
  },
  {
    path: '/admin/notifications/:id',
    component: Notification,
    permissions: {
      action: 'update',
      subjectClass: 'Notification'
    }
  },
  {
    path: '/admin/data-management',
    component: DataImport,
    permissions: {
      action: 'import',
      subjectClass: 'data'
    }
  },
  {
    path: '/admin/data-export',
    component: DataExport,
    permissions: {
      action: 'export',
      subjectClass: 'data'
    }
  },
  {
    path: '/admin/categories',
    component: Categories,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Category'
    }
  },
  {
    path: '/admin/categories/new',
    component: EditCategory,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Category'
    }
  },
  {
    path: '/admin/categories/:id',
    component: EditCategory,
    permissions: {
      action: 'update',
      subjectClass: 'Category'
    }
  },
  {
    path: '/admin/brands',
    component: Brands,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Brand'
    }
  },
  {
    path: '/admin/brands/new',
    component: EditBrand,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Brand'
    }
  },
  {
    path: '/admin/brands/:id',
    component: EditBrand,
    permissions: {
      action: 'update',
      subjectClass: 'Brand'
    }
  },
  {
    path: '/admin/products',
    component: Products,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Product'
    }
  },
  {
    path: '/admin/products/new',
    component: NewProduct,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Product'
    }
  },
  {
    path: '/admin/products/:id',
    component: NewProduct,
    permissions: {
      action: 'update',
      subjectClass: 'Product'
    }
  },
  {
    path: '/admin/promotions',
    component: Promotions,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Promotion'
    }
  },
  {
    path: '/admin/promotions/new',
    component: NewPromotion,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Promotion'
    }
  },
  {
    path: '/admin/promotions/:id',
    component: NewPromotion,
    permissions: {
      action: 'update',
      subjectClass: 'Promotion'
    }
  },
  {
    path: '/admin/promotional_banners',
    component: PromotionalBanners,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'PromotionalBanner'
    }
  },
  {
    path: '/admin/promotional_banners/new',
    component: NewPromotionalBanner,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'PromotionalBanner'
    }
  },
  {
    path: '/admin/promotional_banners/:id',
    component: NewPromotionalBanner,
    permissions: {
      action: 'update',
      subjectClass: 'PromotionalBanner'
    }
  },
  {
    path: '/admin/upsell_popups',
    component: UpsellPopups,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'UpsellPopup'
    }
  },
  {
    path: '/admin/upsell_popups/new',
    component: NewUpsellPopup,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'UpsellPopup'
    }
  },
  {
    path: '/admin/upsell_popups/:id',
    component: NewUpsellPopup,
    permissions: {
      action: 'update',
      subjectClass: 'UpsellPopup'
    }
  },
  {
    path: '/admin/orders',
    component: Orders,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Order'
    }
  },
  {
    path: '/admin/order_limits',
    component: OrderLimits,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'Order'
    }
  },
  {
    path: '/admin/order-limits/:id/edit',
    component: EditOrderLimit,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'Order'
    }
  },
  {
    path: '/admin/staff-reward/settings',
    component: StaffRewardSettings,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'StaffRewardSetting'
    }
  },
  {
    path: '/admin/staff-reward/redemptions',
    component: StaffRewardRedemptions,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Redemption'
    }
  },
  {
    path: '/admin/prizes',
    component: PrizesPage,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'StaffRewardSetting'
    }
  },
  {
    path: '/admin/prizes/new',
    component: PrizeFormPage,
    permissions: {
      action: 'manage',
      subjectClass: 'StaffRewardSetting'
    }
  },
  {
    path: '/admin/prizes/:id',
    component: PrizeFormPage,
    permissions: {
      action: 'manage',
      subjectClass: 'StaffRewardSetting'
    }
  },
  {
    path: '/admin/ppc/settings',
    component: PpcSettings,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'PrepaidCardSetting'
    }
  },
  {
    path: '/admin/ppc/management',
    component: PpcManagement,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'PpcUser'
    }
  },
  {
    path: '/admin/ppc/management/:id',
    component: PpcUser,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'PpcUser'
    }
  },
  {
    path: '/admin/ppc/management/:userId/loads/new',
    component: PpcManualLoad,
    exact: true,
    permissions: {
      action: 'manual-load',
      subjectClass: 'PpcUser'
    }
  },
  {
    path: '/admin/ppc/management/:userId/loads/:loadId',
    component: PpcLoad
  },
  {
    path: '/admin/points-expiry',
    component: PointsExpiry,
    permissions: {
      action: 'manage',
      subjectClass: 'PointExpiry'
    }
  },
  {
    path: '/admin/points-transactions',
    component: PointsTransactions,
    permissions: {
      action: 'index',
      subjectClass: 'PointTransaction'
    }
  },
  {
    path: '/admin/manual-points-transactions',
    component: ManualPointsTransactions,
    permissions: {
      action: 'create',
      subjectClass: 'PointTransaction'
    }
  },
  {
    path: '/admin/sales_incentives',
    component: Incentives,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'Incentive'
    }
  },
  {
    path: '/admin/stock_it_incentives',
    component: AdminStockItIncentives,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'StockItIncentive'
    }
  },
  {
    path: '/admin/stock_it_incentives/new',
    component: AddStockItIncentives,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'StockItIncentive'
    }
  },
  {
    path: '/admin/sales_incentives/new',
    component: AddIncentives,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Incentive'
    }
  },
  {
    path: '/admin/sales_incentives/:id',
    component: AddIncentives,
    permissions: {
      action: 'update',
      subjectClass: 'Incentive'
    }
  },
  {
    path: '/admin/stock_it_incentives/:id',
    component: AddStockItIncentives,
    permissions: {
      action: 'update',
      subjectClass: 'StockItIncentive'
    }
  },
  {
    path: '/admin/news/categories',
    component: NewsCategories,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'new_categories_and_articles'
    }
  },
  {
    path: '/admin/news/categories/new',
    component: EditNewsCategories,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'NewsCategory'
    }
  },
  {
    path: '/admin/news/categories/:id',
    component: EditNewsCategories,
    permissions: {
      action: 'update',
      subjectClass: 'NewsCategory'
    }
  },
  {
    path: '/admin/news/articles',
    component: NewsArticles,
    exact: true,
    permissions: {
      action: 'index',
      subjectClass: 'new_categories_and_articles'
    }
  },
  {
    path: '/admin/news/articles/new',
    component: EditNewsArticles,
    exact: true,
    permissions: {
      action: 'create',
      subjectClass: 'Article'
    }
  },
  {
    path: '/admin/news/articles/:id',
    component: EditNewsArticles,
    permissions: {
      action: 'update',
      subjectClass: 'Article'
    }
  },

  {
    path: '/admin/edit-tile/:id',
    component: EditTile
  },
  {
    path: '/admin/dynamic-edit-tile/:id',
    component: DynamicEditTile
  },
  {
    path: '/admin/downloads',
    component: Downloads,
    exact: true
  },
  {
    path: '/admin/downloads/:id',
    component: EditDownload
  },
  {
    path: '/admin/feature-toggles',
    component: FeatureTogglesList,
    exact: true
  },
  {
    path: '/admin/feature-toggles/:id',
    component: featureToggleFormPage
  },
  {
    path: '/admin/games',
    component: Games,
    exact: true,
    permissions: {
      action: 'manage',
      subjectClass: 'Game'
    }
  },
  {
    path: '/admin/games/new',
    component: GameFormPage,
    exact: true,
    permissions: {
      action: 'add',
      subjectClass: 'Game'
    }
  },
  {
    path: '/admin/games/:id',
    component: GameFormPage,
    permissions: {
      action: 'modify',
      subjectClass: 'Game'
    }
  }
];

export const bluPaths = ['about-vaping', 'myblu', 'educating-your-customer'];



// WEBPACK FOOTER //
// ./src/data/routes.js